export function isAppWebView() {
  return (
    typeof navigator !== "undefined" &&
    navigator.userAgent.includes("pg-app-webview/1.0.0")
  );
}